import React from 'react';
import {css, StyleSheet} from "aphrodite";
import GridStyle from "../styles/styles";
import Config from "../config/Config";
import Image from "./containers/Image";
import TextDiv from "./containers/TextDiv";
import {useSelector} from "react-redux";
import FeedbackButton from "./FeedbackButton";
import MediaQuery from "../styles/MediaQuery";

const Header = ({extraStyle, shadow}) => {
    const {isMobile} = useSelector(state => state.styles),
        styles = StyleSheet.create({
            container: {
                ...GridStyle.define("1fr", "max-content 22px max-content 19px max-content 12px max-content auto max-content 20px max-content"),
                backgroundColor: Config.colors.HEADER_BACKGROUND,
                zIndex: 1,
                padding: "15px 22px 15px 20px",
                width: "-webkit-fill-available",
                position: "fixed",
                overflow: "hidden",
                transition: "box-shadow 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)",
                alignItems: "center",
                userSelect: "none",
                ...MediaQuery.mobile({
                    ...GridStyle.define("1fr", "max-content auto max-content 16px max-content"),
                    padding: "12px 16px"
                })
            },
            brandLogo: {
                ...GridStyle.setRowCol(1, 1),
                height: 28,
                width: 90,
                cursor: "pointer"
            },
            separator: {
                ...GridStyle.setRowCol(1, 3),
                height: 28,
                borderLeft: `1px solid ${Config.colors.HEADER_SEPARATOR}`
            },
            headerLogo: {
                ...GridStyle.setRowCol(1, 5),
                height: 28,
                width: 28,
            },
            headerText: {
                ...GridStyle.setRowCol(1, 7),
                color: Config.colors.MAIN_TEXT,
                fontSize: 17,
                lineHeight: 1.18,
                fontWeight: "bold"
            },
            faq: {
                ...GridStyle.setRowCol(1, 9),
                color: Config.colors.MAIN_TEXT,
                fontSize: 15,
                lineHeight: 1.33,
                cursor: "pointer",
                ...MediaQuery.mobile({
                    ...GridStyle.setRowCol(1, 3),
                    fontSize: 14,
                    lineHeight: 1.43
                })
            },
            download: {
                ...GridStyle.setRowCol(1, 11),
                borderRadius: 20,
                ...MediaQuery.mobile({
                    ...GridStyle.setRowCol(1, 5)
                })
            },
            shadow: {
                boxShadow: "0 2px 8px 0 rgba(38, 28, 106, 0.1)"
            }
        }),
        downloadButtonText = isMobile ? Config.messages.download : Config.messages.downloadNow;

    function openMainPage() {
        openPage(Config.resources.WEB_LINK);
    }

    function openFaq() {
        openPage(Config.resources.FAQ_LINK);
    }

    function openPage(link) {
        window.open(link, "_blank");
    }

    return (
        <div id={Config.styles.HEADER_ID} className={css(styles.container, extraStyle, shadow ? styles.shadow : null)}>
            <Image src={Config.images.HEADER_BRAND_LOGO} extraStyle={styles.brandLogo} onClick={openMainPage}/>
            {!isMobile && <React.Fragment>
                <TextDiv extraStyle={styles.separator} text={""}/>
                <Image extraStyle={styles.headerLogo} src={Config.images.HEADER_BROWSER_LOGO}/>
                <TextDiv extraStyle={styles.headerText} text={Config.messages.browserName}/>
            </React.Fragment>}
            <TextDiv extraStyle={styles.faq} text={Config.messages.faq} onClick={openFaq}/>
            <FeedbackButton header={true} text={downloadButtonText} extraStyle={styles.download}/>
        </div>
    );
};

export default Header;
